import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { Base64UrlService } from '@app/services/base64url.service';
import { SpreadsheetHeader, SpreadsheetSnapshot, SpreadsheetRow } from '@app/core/components/spreadsheet/spreadsheet.component';

@Injectable({ providedIn: 'root' })
export class DataImportService {
    constructor(private readonly datatask: DataTaskService, private readonly base64: Base64UrlService) {}
    /** @datatask 881 */
    public async getSettings(): Promise<DataImportGet> { return (await this.datatask.Post(881, {}))[0]; }
    /** @datatask 876 */
    public async importRecords(page: DataImportGet, spreadsheet: SpreadsheetSnapshot, headers: SpreadsheetHeader[], verify: 0 | 1): Promise<DataImportResult> {
        const order = headers.map(header => header.value);
        const records = spreadsheet.records.filter(row => Object.keys(row).length > 0);
        const keys = Object.keys(records[0] ?? {}).sort((a, b) => order.indexOf(a) - order.indexOf(b));
        // Preserve the legacy field/row delimiters and skip completely empty spreadsheet rows.
        const serialized = records.map(row => keys.map(key => String(row[key])).join('|§|')).join('|#|');
        return (await this.datatask.Post(876, {
            p2_importproc_keyno: page.p2_importproc_keyno, table_name_destination: page.table_name_destination,
            show_table_name_destination: page.show_table_name_destination, filename: spreadsheet.filename, verify,
            headerdata: this.base64.urlEncode(JSON.stringify(order)), records: this.base64.urlEncode(serialized),
        }))[0];
    }
    public exportRecords(page: DataImportGet): Promise<SpreadsheetRow[]> {
        return this.datatask.Post(Number(page.p2_datatask_keyno), {
            p2_exportproc_keyno: page.p2_exportproc_keyno, searchtext: page.searchtext,
            show_table_name_export: page.show_table_name_export, table_name_export: page.table_name_export,
        });
    }
    public encodeFileRecords(records: SpreadsheetRow[]): string { return this.base64.urlEncode(JSON.stringify(records)); }
}
export interface DataImportGet {
    p2_importproc_keyno: string | number; p2_exportproc_keyno: string | number; encodingtype: string;
    p2_datatask_keyno?: string | number; searchtext?: string;
    table_name_destination?: string; show_table_name_destination?: '0' | '1';
    table_name_export?: string; show_table_name_export?: '0' | '1';
}
export interface DataImportResult { exec_resultcode?: string; exec_message: string; }
